<template>
    <div class="pl-16px text-16px line-height-28px">
        <MdPreview :modelValue="automaticSpeechMetrics" :language="currentLanguage" />
    </div>
</template>

<script setup lang="ts">
import serviceMd from '@/doc/service.md';
import serviceEnMd from '@/doc/service-en.md';
import { LocaleTypeEnum } from '@/store/locale';
import { MdPreview } from 'md-editor-v3';
import 'md-editor-v3/lib/preview.css';
const { getCurrentLocale } = useStore('locale');
const currentLanguage = computed(() => (getCurrentLocale.value === LocaleTypeEnum.English ? 'en-US' : 'zh-CN'));
const automaticSpeechMetrics = computed(() => (getCurrentLocale.value === LocaleTypeEnum.English ? serviceEnMd : serviceMd));
</script>
